import axios from 'axios'
import { host } from '../../configuraciones'
import {createAsyncThunk,createSlice} from '@reduxjs/toolkit'

//constantes
const dataInicial = {
    data: {},
    fc_05: {},
    loading: false,
    fc_05Map: {},
    modoProceso:false,
    modoVerDetalle:false,
    modoRecibidasCorregidas:false,
}

//types
const OBTENER_FC_05_DETALLE_EXITO = 'OBTENER_FC_05_DETALLE_EXITO'
const ACTUALIZAR_FC_05_ESTATUS_EXITO = 'ACTUALIZAR_FC_05_ESTATUS_EXITO'
const AGREGAR_FC_05_EXITO_MAP = 'AGREGAR_FC_05_EXITO_MAP'
const OBTENER_ID_CLIENTE_EXITO = 'OBTENER_ID_CLIENTE_EXITO'
const OBTENER_FC_05_MAP_EXITO = 'OBTENER_FC_05_MAP_EXITO'
const AGREGAR_FC_05_EXITO = 'AGREGAR_FC_05_EXITO'
const ACTUALIZAR_FC_05_EXITO = 'ACTUALIZAR_FC_05_EXITO'
const GENERAR_OFICIOS_FC05_EXITO = 'GENERAR_OFICIOS_FC05_EXITO'
export const actualizarFC_05Estatus = createAsyncThunk(
    ACTUALIZAR_FC_05_ESTATUS_EXITO,
    async (data) => {
        try {
            const fullUrl = host + 'Estatus/actualizarEstatusTablas'
            const result = await axios.post(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)
export const obtenerFC_05SolicitudDetalle = createAsyncThunk(
    OBTENER_FC_05_DETALLE_EXITO,
    async (idSolicitud) => {
        try {
            const fullUrl = host + `FC_05/obtenerFormatoFC05_ConDetalle/${idSolicitud}`
            const res = await axios.get(fullUrl)
            return res.data.data
        } catch (error) {
            console.log(error);
        }
    }
)
export const agregarMapFC_05Accion = createAsyncThunk(
    AGREGAR_FC_05_EXITO_MAP,
    async (data) => {
        try {
            let solicitud = { data: data.solicitud}
            let archivosMap = data.archivosMap
            const agregarFC_05Map = host + 'MapSolicitud/agregarMapFC_05_SolicitudParaAutorizacionUsoMarcaEImagenMap'
            const agregarFC_05ArchivosMap = host + `MapSolicitud/agregarMapFC_05_ArchivosGenerales`
            const res = await axios.post(agregarFC_05Map, solicitud)
            for (const anexo of archivosMap) {
                await axios.post(agregarFC_05ArchivosMap, { data: anexo })
            }
            return res
        } catch (error) {
            console.log(error)
        }
    }
)
export const actualizarFC_05Solicitud = createAsyncThunk(
    ACTUALIZAR_FC_05_EXITO,
    async (data) => {
        try {
            const solicitud = { data: data.solicitud }
            const archivos = data.archivos

            const actualizarFC_05 = host + `FC_05/actualizarFC_05UsoDeMarca`
            const urlActualizarArchivos = host + 'FC_05/actualizarArchivoFC_05'
            const res = await axios.put(actualizarFC_05, solicitud)
            for (const anexo in archivos) {
                let resAnexo = await axios.put(urlActualizarArchivos, { data: archivos[anexo] })
            }
            return res
        } catch (error) {
            console.log(error)
        }
    }
)
export const obtenerFC_05Map = createAsyncThunk(
    OBTENER_FC_05_MAP_EXITO,
    async (solicitudId) => {
        try {
            const fullUrl = host + `MapSolicitud/obtenerMapFC_05_SolicitudParaAutorizacionUsoMarcaEImagenMap/${solicitudId}`
            const res = await axios.get(fullUrl)
            const Map = await obtenerAchivosMap(solicitudId)
            return { data: res.data.data, filesMap: Map.filesGeneralMap }
        } catch (error) {
            console.log(error)
        }
    }
)
const obtenerAchivosMap = async (idSolicitud) => {
    try {
        const fullUrl = host + `FC_05/obtenerFormatoFC05_ConDetalle/${idSolicitud}`
        const obtenerArchivosGeneralMap = host + `MapSolicitud/obtenerMapFC_05_ArchivosGenerales/`
        const res = await axios.get(fullUrl)
        const filesGeneral = res.data.data.fc_05archivos
        const filesGeneralMap = []

        for (const i in filesGeneral) {
            const resfiles = await axios.get(obtenerArchivosGeneralMap + filesGeneral[i].idfc_05archivos)
            if (resfiles.data.data) {
                resfiles.data.data.idAnexoBD = resfiles.data.data.idfc_05archivos
                resfiles.data.data.nameid = ""
                filesGeneralMap.push(resfiles.data.data)
            }
        }
        let Map = { filesGeneralMap: filesGeneralMap }
        return Map
    } catch (error) {
        console.log(error);
    }
}
export const actualizarFC_05SolicitudMap = createAsyncThunk(
    ACTUALIZAR_FC_05_EXITO,
    async (data) => {
        try {
            const solicitud = { data: data.solicitud }
            const archivosMap = data.archivosMap
            const actualizarFC_05Map = host + `MapSolicitud/actualizarMapFC_05_SolicitudParaAutorizacionUsoMarcaEImagenMap`
            
            const urlAgregarArchivos = host + 'MapSolicitud/agregarMapFC_05_ArchivosGenerales'
            const urlActualizarArchivos = host + 'MapSolicitud/actualizarMapFC_05_ArchivosGenerales'
            const res = await axios.put(actualizarFC_05Map, { data: solicitud.data })
            for (let anexo of archivosMap) {
                if (anexo.idfc_05archivosmap != "" && anexo.idfc_05archivosmap != null && anexo.idfc_05archivosmap != undefined) {
                    let resAnexo = await axios.put(urlActualizarArchivos, { data: anexo })
                } else {
                    delete anexo.idfc_05archivosmap
                    let resAnexo = await axios.post(urlAgregarArchivos, { data: anexo })
                }
                    
            }
            return res
        } catch (error) {
            console.log(error)
        }
    }
)
export const generarDocumentosFC_05 = createAsyncThunk(
    GENERAR_OFICIOS_FC05_EXITO,
    async (data) => {
        try {
            const fullUrl = host + 'AtencionAClientes/generarOficios'
            const result = await axios.post(fullUrl, data)
            return {}
        } catch (error) {
            console.log(error);
        }
    }
)




export const obtenerIdCliente = createAsyncThunk(
    OBTENER_ID_CLIENTE_EXITO,
    async (idlogin) => {
        try {
            const fullUrl = host + `AnexoUsuario/obtenerClientePorIdLogin/${idlogin}`
            const res = await axios.get(fullUrl)
            return res
        } catch (error) {
            console.log(error);
        }
    }
)


export const actualizarFC_05 = createAsyncThunk(
    AGREGAR_FC_05_EXITO,
    async (data) => {
        try {
            const solicitud = {data: data.solicitud}
            const agregarFC_05 = host + `FC_05/actualizarFormatoFC05`
            const res = await axios.put(agregarFC_05, solicitud)
    
            
            return data
        } catch (error) {
            console.log(error)
        }
    }
)
export const actualizarFC_05Map = createAsyncThunk(
    AGREGAR_FC_05_EXITO,
    async (data) => {
        try {
            const solicitud = {data: data.solicitud}
            const agregarFC_05 = host + `MapSolicitud/actualizarMapFC_05_SolicitudParaAutorizacionUsoMarcaEImagenMap`
            const res = await axios.put(agregarFC_05, solicitud)
            return data
            
        } catch (error) {
            console.log(error)
        }
    }
)

export const fc05Slice = createSlice({
    name: 'fc05Slice',
    initialState: dataInicial,
    reducers: {
        guardarCambiosFC_05Solicitud(state, {payload}) {
        state.fc_05 = payload
        }, 
        resetDataFC_05(state,{payload}) {
            return dataInicial
        },
        setModoProcesoFC_05(state, { payload }) {
            state.modoProceso = payload
        },
        setModoVerDetalleFC_05(state, { payload }) {
            state.modoVerDetalle = payload
        },
        setModoRecibidasCorregidasFC_05(state, { payload }) {
            state.modoRecibidasCorregidas = payload
        },
    },
    extraReducers: {
        [agregarMapFC_05Accion.fulfilled]: (state, {payload}) => {
            
        },
        [actualizarFC_05Estatus.fulfilled]: (state, {payload}) => {
        },
        [obtenerFC_05SolicitudDetalle.fulfilled]: (state, {payload}) => {
            state.data = payload
        },
        [obtenerFC_05Map.fulfilled]: (state, { payload }) => {
            state.fc_05Map = payload.data
            state.filesMap = payload.filesMap
        },
        [actualizarFC_05.fulfilled]: (state, {payload}) => {
        },
    },
})

export const {guardarCambiosFC_05Solicitud,resetDataFC_05,
    setModoProcesoFC_05,setModoVerDetalleFC_05,setModoRecibidasCorregidasFC_05 } = fc05Slice.actions
export const FC05ReducerAtencionACliente = fc05Slice.reducer